import { Banner } from 'ui';
import { useSubscriptionRenewalBanner } from '../hooks';

type SubscriptionRenewalBannerProps = {
  identityCenterApiUrl: string;
  selectedApp: 'sr' | 'compliance';
  storageScope: string;
};

export const SubscriptionRenewalBanner = ({
  identityCenterApiUrl,
  selectedApp,
  storageScope,
}: SubscriptionRenewalBannerProps) => {
  const { dismiss, isProcessingAction, isVisible, openCustomerPortal, scheduledCancellationAt } =
    useSubscriptionRenewalBanner({
      identityCenterApiUrl,
      selectedApp,
      storageScope,
    });

  if (!isVisible) {
    return null;
  }

  return (
    <Banner onClose={dismiss} closeLabel="Close subscription renewal banner">
      <>
        Your access is scheduled to end
        {scheduledCancellationAt ? (
          <>
            {' '}
            on{' '}
            <time dateTime={scheduledCancellationAt}>
              {formatBannerDate(scheduledCancellationAt)}
            </time>
          </>
        ) : null}
        . Renew in the customer portal to avoid interruption to your selected apps:{' '}
        <button
          type="button"
          className="inline font-semibold underline underline-offset-2 hover:opacity-70 disabled:cursor-not-allowed disabled:no-underline disabled:opacity-60"
          onClick={() => void openCustomerPortal()}
          disabled={isProcessingAction}
        >
          {isProcessingAction ? 'opening customer portal' : 'review billing and renew'}
        </button>
        .
      </>
    </Banner>
  );
};

function formatBannerDate(value: string) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return 'the scheduled cancellation date';
  }

  return new Intl.DateTimeFormat('en-AU', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(date);
}
